import api from 'api';

export const loadTable = api('POST /api/creatives-tracker/grid');
export const loadMetrics = api('GET /api/creatives-tracker/metrics');
export const loadDimensions = api('GET /api/creatives-tracker/dimensions');
export const loadMetricsAdvancedList = api(
  'GET /api/creatives-tracker/metrics/advanced/list'
);
export const loadMetricsAdvancedOperators = api(
  'GET /api/creatives-tracker/metrics/advanced/operators'
);
